import useVisitPayloadTab from './hooks';
import styles from './VisitPayloadTab.module.scss';

const VisitPayloadTab = () => {
  const visitPayloadInfo = useVisitPayloadTab();

  const renderVisitPayloadInfo = () => (
    <div>
      <pre>{visitPayloadInfo}</pre>
    </div>
  );

  return <div className={styles.visitPayloadTab}>{renderVisitPayloadInfo()}</div>;
};

export default VisitPayloadTab;
